/**
 * The band over the bottom of a designed room's preview still on the results
 * page: before the estimate is saved, an invitation to save it for the
 * photoreal renders and the full materials list; once saved, a note that
 * the renders are on their way (the saved page shows their progress).
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import './RenderPromptBanner.css';

export interface RenderPromptBannerProps {
  variant: 'prompt' | 'queued';
}

export const RenderPromptBanner: React.FC<RenderPromptBannerProps> = ({ variant }) => {
  const { t } = useTranslation('results');
  const key = variant === 'queued' ? 'queued' : 'prompt';
  return (
    <div className={`render-prompt-banner render-prompt-banner--${variant}`} role="note">
      <div className="render-prompt-banner-inner">
        <Sparkles size={22} className="render-prompt-banner-icon" aria-hidden="true" />
        <div>
          <div className="render-prompt-banner-title">{t(`designerPreview.${key}Title`)}</div>
          <div className="render-prompt-banner-body">{t(`designerPreview.${key}Body`)}</div>
        </div>
      </div>
    </div>
  );
};

export default RenderPromptBanner;
